import i18n from 'i18next';
// import XHR from 'i18next-xhr-backend';
// import Cache from 'i18next-localstorage-cache';
import LanguageDetector from 'i18next-browser-languagedetector';
//import common_en from '../locales/en/common.json'
//import common_fr from '../locales/fr/common.json'
import common_en from '../src/i18n/en/resources.json'
import common_fr from '../src/i18n/fr/resources.json'
import common_es from '../src/i18n/es/resources.json'
import common_de from '../src/i18n/de/resources.json'




i18n
  // .use(XHR)
  // .use(Cache)
  .use(LanguageDetector)
  .init({
    // backend: {
    //   //loadPath: '/api/locales/{{lng}}/{{ns}}.json'
    //   loadPath: '../src/i18n/{{lng}}/{{common}}.json'
    
    // },
    resources: {
      en: {
        common: common_en
      },
      fr: {
        common: common_fr
      },
      de:{
        common: common_de
      },
      es:{
        common: common_es
      }
    },
    fallbackLng: 'en',
    // have a common namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',
    debug: false,
    
    // cache: {
    //   enabled: true
    // },
    translateFuncName: 't',
    // withRef: true,
    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
      format: function(value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      }
    }
  });



export default i18n;





